module.exports = __webpack_public_path__ + "media/images/warnings/warning_5-980a56675df895034427ce8e16d04353.svg";